// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3OWQ9","noInteraction":"EventWrapper_noInteraction__V0jXA","pointerPassthrough":"EventWrapper_pointerPassthrough__agdJB"};